<template>
  <div style>
    <!-- <van-loading v-if="loading" size="24px" vertical style="position:absolute;top:center;">加载中...</van-loading> -->
    <div v-if="newest.length>0" :class="tmpServer.length<3?'legend-box sy-cell_flexEnd':'legend-box'">
      <div v-for="(item,index) in tmpServeList" :key="index" class="legend-item sy-cell_flexEnd">
        <span class="legend-icon" :style="{background:tmpServer.length<3?colorList[index]:'none'}" />
        {{ item.name }}
        <div v-if="item.childNode" class="sy-cell leg-sec">（&nbsp;
          <div v-for="(itemChild,indexChild) in item.childNode" :key="indexChild">
            <span class="legend-icon" :style="{background:colorList[2*index + indexChild]}" />{{ itemChild.name }}&nbsp;&nbsp;
          </div>
          ）</div>
      </div>
      <!-- <div class="legend-item"><span class="legend-icon" :style="{background:colorList[1]}" /> {{ typeDate==='WEEK'?'上周':'上月' }}</div> -->
    </div>
    <div id="echarts" />
  </div>
</template>
<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/dataZoom')
require('echarts/lib/component/legend')
export default {
  name: 'EchartLine',
  props: {
    'dataX': {
      type: Array,
      default: function() {
        return []
      }
    },
    'dataY': {
      type: Array,
      default: function() {
        return []
      }
    },
    'newest': {
      type: Array,
      default: function() {
        return []
      }
    },
    'old': {
      type: Array,
      default: function() {
        return []
      }
    },
    typeDate: {
      type: String,
      default: 'WEEk'
    },
    tmpServer: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      echarts: null,
      colorList: ['#F18937', '#37B2F1', '#E37FEF', '#98F7FD'],
      tmpServeList: [],
      loading: true
    }
  },
  watch: {
    dataX: {
      immediate: true,
      deep: true,
      handler(val) {
        this.dataX = val
        if (!this.echarts) {
          return
        }
        this.init()
        this.tmpServer.map((item, index) => {
          if (item.name === this.tmpServer[0].name && index > 1) {
            var name = [{
              name: this.typeDate === 'WEEK' ? this.$t('viewBase.a55') : this.$t('viewBase.a56'),
              childNode: this.tmpServer.slice(0, index)
            }, {
              name: this.typeDate === 'WEEK' ? this.$t('viewBase.a57') : this.$t('viewBase.a58'),
              childNode: this.tmpServer.slice(index, this.tmpServer.length)
            }]
            this.tmpServeList = name
          } else if (this.tmpServer.length < 3 && index === this.tmpServer.length - 1) {
            this.tmpServeList = this.tmpServer.slice(0, this.tmpServer.length)
            // this.tmpServeList.reverse()
          }
        })
        this.tmpServer.reverse()
        // this.loading = false
      }
    }
  },
  mounted() {
    this.echarts = echarts.init(document.getElementById('echarts'))
  },
  methods: {
    init() {
      this.echarts.setOption({
        color: ['#F18937', '#37B2F1', '#E37FEF', 'green'],
        grid: {
          left: '4%', // 图表距边框的距离
          top: '5%',
          bottom: '5%',
          right: '4%',
          containLabel: true
        },
        dataZoom: [{
          type: 'inside',
          moveOnMouseMove: true,
          zoomLock: true,
          startValue: this.dataX.length > 7 ? this.dataX[this.dataX.length - 7] : this.dataX[0],
          endValue: this.dataX[this.dataX.length - 1]
        }],
        xAxis: [
          {
            type: 'category',
            axisLine: {
              inside: true,
              lignWithLabel: true,
              lineStyle: {
                color: '#e0e0e0'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#171717',
              fontSize: 9,
              interval: 0
            },
            data: this.dataX
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#171717',
              fontSize: 9
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#e0e0e0'
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        // series: [
        //   {
        //     name: '本周',
        //     type: 'line',
        //     animation: false,
        //     symbol: 'circle',
        //     symbolSize: 8,
        //     smooth: true,
        //     lineStyle: {
        //       width: 2
        //     },
        //     data: this.newest
        //   },
        //   {
        //     name: '上周',
        //     type: 'line',
        //     animation: false,
        //     symbol: 'circle',
        //     symbolSize: 8,
        //     smooth: true,
        //     lineStyle: {
        //       width: 2
        //     },
        //     data: this.old
        //   }
        // ]
        series: this.tmpServer
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#echarts{
  width: 100%;
  min-height:165px;
}
.legend-box{
  width: 100%;
  padding:10px 4%;
}
.legend-icon{
  display: inline-block;
  width:3px;
  height:10px;
  background:rgba(241,137,55,1);
  margin-right: 3px;
}
.legend-item{
  font-size: 9px;
  margin-right: 6px;
  color:#7D7D7D;

}
</style>
